import { createStyles, makeStyles } from '@material-ui/core/styles';
import React, { ReactNode } from 'react';

import { Footer } from 'features/Footer';

export const useStyles = makeStyles(theme =>
  createStyles({
    root: {
      display: 'flex',
      minHeight: '100vh',
      flexDirection: 'column',
      justifyContent: 'space-between',
    },
    form: {
      marginBottom: `${theme.spacing(2)}px`,
      padding: theme.spacing(2),
    },
    toolbar: theme.mixins.toolbar,
    content: {
      display: 'flex',
      flexDirection: 'column',
      margin: '0 auto',
      maxWidth: 680,
    },
  }),
);

export interface ApplicationFormEmbeddedLayoutProps {
  helpEmail?: string;
  children?: React.ReactNode;
  languageBanner?: ReactNode;
  upsAccount?: boolean;
}

export const ApplicationFormEmbeddedLayout: React.FC<
  ApplicationFormEmbeddedLayoutProps
> = ({ children, helpEmail, languageBanner, upsAccount }) => {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      {languageBanner && (
        <>
          <div className={classes.toolbar} />
          {languageBanner}
        </>
      )}
      <main className={classes.content}>
        <div className={classes.form}>{children}</div>
      </main>
      <Footer helpEmail={helpEmail} isUpsAccount={upsAccount} />
    </div>
  );
};
